import { motion } from 'motion/react';
import MarketingNav from '../components/MarketingNav';
import MarketingFooter from '../components/MarketingFooter';

export default function About() {
  return (
    <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-slate-900 selection:text-white flex flex-col">
      <MarketingNav />

      <main className="flex-1 pt-32 pb-24 px-6 md:px-12">
        <div className="max-w-3xl mx-auto">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900 mb-10 leading-tight"
          >
            Built by a litigation lawyer for litigation lawyers.
          </motion.h1>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="space-y-8 text-lg md:text-xl text-slate-700 leading-relaxed font-medium"
          >
            <p>
              LexGat was born from a simple observation: litigation lawyers in Pakistan handle complex, high-stakes work, but much of their practice is still managed through manual diaries, physical files, scattered documents, and memory.
            </p>
            <p>
              LexGat is being built to give lawyers a structured, intelligent, and practical system that matches how litigation actually works in Pakistani courts.
            </p>

            <div className="mt-16 pt-12 border-t border-slate-200">
              <h2 className="text-sm font-bold tracking-widest text-slate-400 uppercase mb-6">A Note from the Founder</h2>
              <blockquote className="text-xl md:text-2xl text-slate-900 leading-relaxed italic border-l-4 border-slate-200 pl-6">
                “LexGat is not designed as generic law firm software. It is being built around the realities of Pakistani litigation — court dates, proceedings, fixed-for stages, drafting needs, case files, and the way lawyers actually work.”
              </blockquote>
            </div>
          </motion.div>
        </div>
      </main>

      <MarketingFooter />
    </div>
  );
}
